import { createSlice } from '@reduxjs/toolkit';
import {
  approveOrder,
  declineOrder,
  getUnapprovedOrders,
  closeApproveDialog,
  closeDeclineDialog,
  openDeclineDialog,
  clearDeclinedConfirmation,
} from '../../actions/orders/unapprovedActions';

const initialState = {
  data: [],
  pagination: {},
  isLoading: true,
  hasMore: false,
  processingAction: false,
  declineDialogOpened: false,
  approveDialogOpened: false,
  declinedSuccesful: null,
};

const unapprovedReducer = createSlice({
  name: 'unapproved',
  initialState,
  extraReducers: {
    [openDeclineDialog.type]: state => {
      state.declineDialogOpened = true;
    },
    [closeDeclineDialog.type]: state => {
      state.declineDialogOpened = false;
    },
    [closeApproveDialog.type]: state => {
      state.approveDialogOpened = false;
    },
    [declineOrder.pending]: state => {
      state.declineDialogOpened = true;
      state.processingAction = true;
    },
    [declineOrder.rejected]: state => {
      state.declineDialogOpened = false;
      state.processingAction = false;
      state.declinedSuccesful = false;
    },
    [declineOrder.fulfilled]: state => {
      state.declineDialogOpened = false;
      state.processingAction = false;
      state.declinedSuccesful = true;
    },
    [approveOrder.pending]: state => {
      state.approveDialogOpened = false;
      state.processingAction = true;
    },
    [approveOrder.rejected]: state => {
      state.processingAction = false;
    },
    [approveOrder.fulfilled]: state => {
      state.approveDialogOpened = true;
      state.processingAction = false;
    },
    [getUnapprovedOrders.pending]: (state, { meta: { arg } }) => {
      state.declineDialogOpened = false;
      state.approveDialogOpened = false;
      state.isLoading = true;
      arg.pageNumber === 1 && (() => (state.data = []))();
    },
    [clearDeclinedConfirmation.type]: state => {
      state.declinedSuccesful = null;
    },
    [getUnapprovedOrders.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.data = [
        ...(payload.pagination.pageNumber === 1 ? [] : state.data),
        ...payload.orders,
      ];
      state.pagination = payload.pagination;
      state.hasMore =
        payload.pagination.pageNumber < payload.pagination.totalPages;
    },
  },
});

export default unapprovedReducer;
